import { FORMAT } from "./format";
import { WUXING } from "./wuxing";

// 人元司令
var RENYUANSILING = {
    /**
     * 寅月：立春后戊土七日，丙火七日，甲木十六日 立春、雨水。
     * 卯月：惊蛰后甲木十日，乙木二十日。 惊蛰、春分。
     * 辰月：清明后乙木九日，癸水三日，戊土十八日。清明、谷雨。
     * 巳日：立夏后戊土五日，庚金九日，丙火十六日。立夏、小满。
     * 午月：芒种后丙火十日，己土九日，丁火十一日 芒种、夏至。
     * 未月：小暑后丁火九日，乙木三日，己土十八日。小暑、大署。
     * 申月：立秋后戊土十日，壬水三日，庚金十七日。立秋、处暑。
     * 酉月：白露后庚金十日，辛金二十日。 白露、秋分。
     * 戌月：寒露后辛金九日，丁火三日，戊土十八日。寒露、霜降。
     * 亥月：立冬后戊土七日，甲木五日，壬水十八日。立冬、小雪。
     * 子月：大雪后壬水十日，癸水二十日。 大雪、冬至。
     * 丑月：小寒后癸水九日，辛金三日，己土十八日。小寒、大寒。
     * 人元司令配置表
     */
    yuelingArray: [
        {month: '子', dayArr: [10, 10+20], silingArr: [8, 9]},
        {month: '丑', dayArr: [9, 9+3, 9+3+18], silingArr: [9, 7, 5]},
        {month: '寅', dayArr: [7, 7+7, 7+7+16], silingArr: [4, 2, 0]},
        {month: '卯', dayArr: [10, 10+20], silingArr: [0, 1]},
        {month: '辰', dayArr: [9, 9+3, 9+3+18], silingArr: [1, 9, 4]},
        {month: '巳', dayArr: [5, 5+9, 5+9+16], silingArr: [4, 6, 2]},
        {month: '午', dayArr: [10, 10+9, 10+9+11], silingArr: [2, 5, 3]},
        {month: '未', dayArr: [9, 9+3, 9+3+18], silingArr: [3, 1, 5]},
        {month: '申', dayArr: [10, 10+3, 10+3+17], silingArr: [4, 8, 6]},
        {month: '酉', dayArr: [10, 10+20], silingArr: [6, 7]},
        {month: '戌', dayArr: [9, 9+3, 9+3+18], silingArr: [7, 3, 4]},
        {month: '亥', dayArr: [7, 7+5, 7+5+18], silingArr: [4, 0, 8]},
    ],
    
    /**
     * 根据月令和当前节气的信息获取人元司令
     * @param {月令} yuezhi 
     * @param {节气} jieqi 
     */
    getRyslByYueZhiJieqi(yuezhi, jieqi) {
        var tempData = RENYUANSILING.yuelingArray[yuezhi],
            tempDay = parseInt(jieqi[1].slice(1, -1)),
            tempIndex = 0, tempSL = 0,
            tempArr = tempData ? tempData.dayArr : [];
        for(var i = 0; i < tempArr.length; i++) {
            tempIndex = i == 0 && tempDay <= tempArr[i] ? i : tempIndex;
            tempIndex = i > 0 && tempDay > tempArr[i-1] && tempDay < tempArr[i] ? i : tempIndex;
            tempIndex = i > 0 && tempDay >= tempArr[i] ? i : tempIndex;
        }
        tempSL = tempData.silingArr[tempIndex];
        var resultData = {
            text: FORMAT.getTianGanByIndex(tempSL),
            xing: WUXING.getWuXingDataByIndex(WUXING.getTianGanXingByIndex(tempSL))
        }
        // console.log('getRyslByMonthJieQi-------', yuezhi, jieqi, tempSL, resultData)
        return resultData;
    }
}

export {
    RENYUANSILING
}